window.ConfirmationBanner = {};